import React from 'react'
import PropTypes from 'prop-types'
import { Trans } from 'react-i18next'
import i18n from 'core/common/i18n'
import Typography from 'core/components/Typography'

function ProductUploadTitle({ maxSelectableItems }) {
  return (
    <>
      <Typography fontSize="medium" fontWeight="medium" mb={2}>
        {i18n.t('product.productUpload.title')}
      </Typography>
      <ul>
        <Typography fontSize="small" color="textSecondary" component="li">
          <Trans
            i18nKey="product.productUpload.subtitle"
            values={{ maxSelectableItems }}
            components={{ b: <b /> }}
          />
        </Typography>
        <Typography fontSize="small" color="textSecondary" component="li">
          {i18n.t('product.productUpload.imageRequirements2')}
        </Typography>
        <Typography fontSize="small" color="textSecondary" component="li">
          {i18n.t('product.productUpload.imageRequirements3')}
        </Typography>
      </ul>
    </>
  )
}

ProductUploadTitle.defaultProps = {
  maxSelectableItems: null,
}

ProductUploadTitle.propTypes = {
  maxSelectableItems: PropTypes.string,
}

export default ProductUploadTitle
